import * as angular from "angular";
import userModalEntitiesTab from "./user-modal-entities-tab";
import userModalProfileTab from "./user-modal-profile-tab";
import userModalRequestsTab from "./user-modal-requests-tab";

export default angular
	.module("vesl.components.user-modal.tabs", [
		userModalEntitiesTab,
		userModalProfileTab,
		userModalRequestsTab
	])
	.name;
